import { AxiosResponse } from 'axios';
import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError, ShowSuccess } from '../../helper/Alert';
import { getLocaleMsg } from '../../lngProvider';
import { onDeleteFileSuccess, onUploadFileSuccess } from '../actions';

// UploadFile
const uploadFile = async (
  config: any,
  formData: any,
  guid: string,
  letterCode: string,
  type: string,
) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post(
    `letter/uploadFile?letterCode=${letterCode}`,
    formData,
    config,
  );
};

// DeleteFile
const deleteFile = async (guid: string, fileName: string) => {
  const http = await FaraGostarDynamicHttp();
  return http.post(
    `letter/deleteFile?uploadTaskId=${guid}&fileName=${fileName}&type=Attachments`,
  );
};

function* uploadFileRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  const messages = getLocaleMsg();
  try {
    const result = yield call(
      uploadFile,
      action.payload.config,
      action.payload.formData,
      action.payload.guid,
      action.payload.letterCode,
      action.payload.type,
    );

    if (result.status === 200) {
      ShowSuccess(
        messages['messages.FileUpload'],
        messages['messages.UploadIsSuccessfully'],
      );
    }
    yield put(onUploadFileSuccess(action.payload.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fileUpload() {
  yield takeEvery(ActionTypes.UPLOAD_FILE, uploadFileRequest);
}

function* deleteFileRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  const messages = getLocaleMsg();
  try {
    const result = yield call(
      deleteFile,
      action.payload.guid,
      action.payload.fileName,
    );
    if (result.status === 200) {
      ShowSuccess(
        messages['messages.DeleteFile'],
        messages['messages.bodyFileIsSuccessfullyDeleted'],
      );
    }
    yield put(onDeleteFileSuccess());
  } catch (error) {
    return ShowError('', error);
  }
}

export function* deleteUpload() {
  yield takeEvery(ActionTypes.DELETE_FILE, deleteFileRequest);
}

export default function* rootSaga() {
  yield all([fork(fileUpload), fork(deleteUpload)]);
}
